export const SLICE_NAME = 'laborTargets';
